/// setup aws services

import { browser } from '$app/environment';
import {
	PUBLIC_AWS_APPSYNC_APIKEY,
	PUBLIC_AWS_APPSYNC_AUTHENTICATIONTYPE,
	PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT,
	PUBLIC_AWS_APPSYNC_REGION,
	PUBLIC_AWS_PROJECT_REGION,
	PUBLIC_COGNITO_IDENTITY_POOL_ID,
	PUBLIC_COGNITO_USER_POOL_ID,
	PUBLIC_COGNITO_USER_POOL_WEB_CLIENT_ID
} from '$env/static/public';
import { Amplify } from 'aws-amplify';

let inited = false;

export const awsInit = () => {
	// for now site designed use amplify lib on client-side only.
	// read more: https://docs.amplify.aws/lib/ssr/q/platform/js/#enabling-ssr
	if (browser) {
		if (inited) return;
		inited = true;

		Amplify.configure({
			aws_project_region: PUBLIC_AWS_PROJECT_REGION,
			aws_appsync_graphqlEndpoint: PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT,
			aws_appsync_region: PUBLIC_AWS_APPSYNC_REGION,
			aws_appsync_authenticationType: PUBLIC_AWS_APPSYNC_AUTHENTICATIONTYPE,
			aws_appsync_apiKey: PUBLIC_AWS_APPSYNC_APIKEY
		});

		Amplify.configure({
			Auth: {
				userPoolId: PUBLIC_COGNITO_USER_POOL_ID,
				userPoolWebClientId: PUBLIC_COGNITO_USER_POOL_WEB_CLIENT_ID,
				region: PUBLIC_AWS_PROJECT_REGION,
				identityPoolId: PUBLIC_COGNITO_IDENTITY_POOL_ID
			}
		});
	}
};
